export const LIVE_PUBLISH_SUCCESS_EVENT = 'kea:live-publish-success';
export const OPERATOR_STATE_REFRESH_EVENT = 'kea:operator-state-refresh';
export const RUNTIME_OPERATION_STATE_EVENT = 'kea:runtime-operation-state';

export function notifyOperatorStateRefresh() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(OPERATOR_STATE_REFRESH_EVENT));
}

export function notifyRuntimeOperationState(detail) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(RUNTIME_OPERATION_STATE_EVENT, { detail }));
}

export function notifyLivePublishSuccess() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(LIVE_PUBLISH_SUCCESS_EVENT));
  notifyOperatorStateRefresh();
}
